import { render } from "./UpdateUserPassword.vue?vue&type=template&id=4a5b9da5"
import script from "./UpdateUserPassword.vue?vue&type=script&lang=js"
export * from "./UpdateUserPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/geramyan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__